import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    LinearProgress,
    Typography,
    Box,
    CircularProgress,
} from '@mui/material';
import formatWithThousandSeparator from '../../utils/thousand_separator';

const NotificationProgressModal = ({ open, progress, t, sentCount, totalCount }) => {
    return (
        <Dialog open={open} maxWidth="sm" fullWidth data-testid="notification-progress-modal">
            <DialogTitle
                data-testid="notification-progress-title"
                sx={{
                    textAlign: 'center',
                    fontWeight: 600,
                    fontStyle: 'italic',
                    color: '#DE2C48',
                    textAlign: 'left',
                }}
            >
                {t ? t('sending_notification') : 'Sendi tilkynningu'}
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                    <CircularProgress size={24} sx={{ color: '#DE2C48' }} />
                    <Typography data-testid="notification-progress-text">
                        {t('sending_notification_progress', {
                            total: formatWithThousandSeparator(totalCount),
                            left: formatWithThousandSeparator(
                                Math.round((progress / 100) * totalCount) || 0
                            ),
                            percentage: Math.round(progress),
                            defaultValue:
                                'Útsending tilkynningar í gangi: {{left}}/{{total}} ({{percentage}}%)',
                        })}
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                    <LinearProgress
                        variant="determinate"
                        value={progress}
                        data-testid="notification-progress-bar"
                        sx={{
                            height: 10,
                            borderRadius: 5,
                            flex: 1,
                            backgroundColor: '#F8D5DA',
                            '& .MuiLinearProgress-bar': {
                                backgroundColor: '#DE2C48',
                            },
                        }}
                    />
                </Box>
                <Typography
                    variant="body2"
                    data-testid="notification-progress-message"
                    sx={{ mt: 2, color: 'text.secondary', fontStyle: 'italic' }}
                >
                    {t
                        ? t('notification_sending_message')
                        : 'Þú getur lokað þessum glugga. Tilkynningin heldur áfram að berast notendum...'}
                </Typography>
            </DialogContent>
        </Dialog>
    );
};

export default NotificationProgressModal;
